import React from 'react'
import { useSelector } from 'react-redux'
import DemographicsCharts from 'features/DemographicsCharts'
import { useParams } from 'react-router-dom'

const PropjectDemographics = () => {
	const { id } = useParams()

	const { project, loading: projectLoading } = useSelector(state => {
		return {
			loading: state.projects.isLoading,
			success: state.projects.isInitialized,
			project: state.projects.entities[id],
		}
	})

	const locationId = project ? project.projectAsset?._id : null

	const { location, loading } = useSelector(state => {
		return {
			loading: state.locations.isLoading,
			success: state.locations.isInitialized,
			location: state.locations.entities[locationId],
		}
	})

	// TODO - should put a warning that they need lat/long to have this page populate
	if (loading || !location || !location.longitude || !location.latitude) return null
	return <DemographicsCharts asset={location} />
}

export default PropjectDemographics
